export default __webpack_public_path__ + "app/assets/marker-icon-f53f066b.png";